// teamPrimaryColors.js
const TEAM_OPACITY = 0.6; // slightly lower base opacity

const rgba = (r, g, b) => `rgba(${r}, ${g}, ${b}, ${TEAM_OPACITY})`;

// 👇 NOW EXPORTED so you can reuse it (borders, text, etc.)
export const washOut = (rgbaColor, amount = 0.4) => {
  const values = rgbaColor.match(/[\d.]+/g).map(Number);
  let [r, g, b, a] = values;

  // blend toward white (255,255,255)
  r = Math.round(r + (255 - r) * amount);
  g = Math.round(g + (255 - g) * amount);
  b = Math.round(b + (255 - b) * amount);

  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

export const getTeamBackgroundStyle = (teamColor) => {
  const washed = washOut(teamColor, 0.1); // 👈 adjust this (0.1–0.4 sweet spot)

  return {
    position: 'absolute',
    inset: 0,
    zIndex: 1,
    pointerEvents: 'none',
    borderRadius: '8px',

    background: `
      linear-gradient(150deg, ${washed} 1%, transparent 90%),
      linear-gradient(150deg, rgba(70,70,70,1), ${washed.replace(/[\d.]+\)$/, '0.2)')} 100%)
    `,
  };
};

const teamPrimaryColors = {
  'Arizona Diamondbacks': rgba(170, 45, 65),
  'Atlanta Braves': rgba(55, 65, 125),
  'Baltimore Orioles': rgba(230, 95, 40),
  'Boston Red Sox': rgba(195, 70, 80),
  'Chicago White Sox': rgba(165, 165, 165),
  'Chicago Cubs': rgba(40, 70, 155),
  'Cincinnati Reds': rgba(185, 40, 40),
  'Cleveland Guardians': rgba(40, 60, 85),
  'Colorado Rockies': rgba(70, 40, 125),
  'Detroit Tigers': rgba(40, 60, 85),
  'Houston Astros': rgba(40, 65, 115),
  'Kansas City Royals': rgba(40, 85, 145),
  'Los Angeles Angels': rgba(205, 60, 80),
  'Los Angeles Dodgers': rgba(40, 105, 165),
  'Miami Marlins': rgba(40, 170, 220),
  'Milwaukee Brewers': rgba(40, 60, 95),
  'Minnesota Twins': rgba(40, 65, 105),
  'New York Yankees': rgba(40, 60, 85),
  'New York Mets': rgba(40, 75, 135),
  Athletics: rgba(40, 75, 65),
  'Philadelphia Phillies': rgba(235, 60, 70),
  'Pittsburgh Pirates': rgba(245, 195, 60),
  'San Diego Padres': rgba(245, 205, 70),
  'San Francisco Giants': rgba(245, 105, 50),
  'Seattle Mariners': rgba(40, 105, 105),
  'St. Louis Cardinals': rgba(200, 40, 40),
  'Tampa Bay Rays': rgba(40, 65, 105),
  'Texas Rangers': rgba(40, 75, 130),
  'Toronto Blue Jays': rgba(40, 90, 150),
  'Washington Nationals': rgba(185, 40, 40),
};

export default teamPrimaryColors;